<template>
  <main>
    <h1>{{ $t('privacy_policy_title') }}</h1>
    <section>
      <ul>
        <li v-for="(term, idx) in $t('privacy_policy')" :key="idx">
          <h2>{{ term.title }}</h2>
          <p v-for="(par, idxp) in term.body" :key="idxp">{{ par }}</p>
          <ol>
            <li v-for="(line, idxl) in term.list" :key="idxl">{{ line }}</li>
          </ol>
          <p v-for="(extra, idxe) in term.extra" :key="idxe">{{ extra }}</p>
        </li>
      </ul>
    </section>
  </main>
</template>

<script>
export default {
  
}
</script>

<style scoped>
main {
  padding: 2rem 0;
}
h1 {
  text-align: center;
  font-size: 2.75rem;
}
ul {
  list-style: auto;
  max-width: 60em;
  margin: auto;
  padding: 0 6ch;
  font-size: 1.3rem;
}
ul h2 {
  margin-left: 1ch;
  font-size: 1.5rem;
}
ul p {
  margin: 0 -4ch;
}
ol {
  list-style: disc;
  padding-left: 0 6ch;
}
</style>